import type { ComponentProps, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Nav, Navbar, NavbarBrand, NavItem, NavLink } from "reactstrap";
import BonusPoints from "../../components/bonifiedInteractions/BonusPoints";
import { UserAvatar } from "../../components/user/UserAvatar";
import keycloak from "../../keycloak";
import { isLoggedIn } from "../../store/actions/LoginActions";
import { UrlPathBonifiedInteractions, UrlPathMain } from "../../url";
import { SelectTheme } from "../SwitchTheme";

type NavbarProps = Partial<ComponentProps<typeof Navbar>>;
type NavbarBrandProps = Partial<ComponentProps<typeof NavbarBrand>>;
type NavProps = Partial<ComponentProps<typeof Nav>>;

const mergeClassNames = (...classNames: Array<string | undefined>) => {
  const filtered = classNames.filter(Boolean).join(" ");
  return filtered.length > 0 ? filtered : undefined;
};

interface HeaderBaseProps {
  brand: ReactNode;
  navbarProps?: NavbarProps;
  navbarBrandProps?: NavbarBrandProps;
  navProps?: NavProps;
  navStartItems?: ReactNode;
  navEndItems?: ReactNode;
  showThemeSelector?: boolean;
}

export const HeaderBase = ({
  brand,
  navbarProps,
  navbarBrandProps,
  navProps,
  navStartItems,
  navEndItems,
  showThemeSelector = true,
}: HeaderBaseProps) => {
  const handleLogout = () => {
    keycloak.logout();
  };

  const { expand = "xs", className: navbarClassName, ...restNavbarProps } = navbarProps ?? {};
  const { className: brandClassName, ...restNavbarBrandProps } = navbarBrandProps ?? {};
  const {
    className: navClassName,
    navbar: navNavbarProp,
    ...restNavProps
  } = navProps ?? {};

  return (
    <header>
      <Navbar expand={expand} className={navbarClassName} {...restNavbarProps}>
        <NavbarBrand
          className={brandClassName}
          {...(isLoggedIn()
            ? { tag: Link, to: UrlPathMain }
            : {})}
          {...restNavbarBrandProps}
        >
          {brand}
        </NavbarBrand>
        <Nav
          className={mergeClassNames("ml-auto", navClassName)}
          navbar={navNavbarProp ?? true}
          {...restNavProps}
        >
          {navStartItems}
          {isLoggedIn() && (
            <>
              <NavItem>
                <NavLink tag={Link} to={UrlPathBonifiedInteractions}>
                  Deine Bonuspunkte:{" "}
                  <b>
                    <BonusPoints />
                  </b>
                </NavLink>
              </NavItem>
              <NavItem>
                <UserAvatar onLogout={handleLogout} />
              </NavItem>
            </>
          )}
          {showThemeSelector && (
            <NavItem>
              <SelectTheme />
            </NavItem>
          )}
          {navEndItems}
        </Nav>
      </Navbar>
    </header>
  );
};
